import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { BottomNavigation } from './BottomNavigation';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main 
        id="main-content" 
        className="flex-1" 
        role="main" 
        aria-label="Κύριο περιεχόμενο της σελίδας"
      >
        <Outlet />
      </main>
      <Footer />
      <BottomNavigation />
    </div>
  );
}